<template>
  <div>
    <Modal :value="value" title="更新房间号" class="vertical-center-modal" :width="380"
      @on-visible-change="onVisible">
      <Form :label-width="80">
        <FormItem label="新房间号">
          <Input v-model="roomId" placeholder="请输入新房间号" />
        </FormItem>
      </Form>
      <template #footer>
        <dialog-footer @cancel="close" @confirm="next" />
      </template>
    </Modal>
    <!-- 敏感操作:安全密码二次确认 -->
    <safe-password-dialog v-model="safeShow" @confirm="doUpdate" />
  </div>
</template>

<script>
import SafePasswordDialog from '@/components/base/SafePasswordDialog.vue'

export default {
  name: 'UpdateRoomDialog',
  components: { SafePasswordDialog },
  props: { value: { type: Boolean, default: false } },
  data() {
    return { roomId: '', safeShow: false }
  },
  methods: {
    onVisible(v) { if (!v) this.close() },
    close() { this.roomId = ''; this.$emit('input', false) },
    next() {
      if (!this.roomId.trim()) { this.$Message.warning('请输入新房间号'); return }
      this.safeShow = true
    },
    doUpdate(safePwd) {
      this.safeShow = false
      // TODO: 调更新房间号接口(带 safePwd)
      this.$store.commit('setRoom', { id: this.roomId })
      this.$Message.success('房间号已更新(待接口)')
      this.close()
    }
  }
}
</script>
